import {CONFIG} from '../config.js';
import './pcsp.js';

export class SmoothScroll {
	#hash;
	#top = 0;
	constructor(el){
		this.$el = $(el);

		if(this.#urlCheck()) {
			this.#hash = this.$el[0].hash;
			this.#top = (this.#hash ? $(this.#hash).offset().top : 0) - CONFIG.scrollOffset[pcsp.mode];
			this.#scroll()
		}
	}
	
	#urlCheck(){
		const url = new URL(this.$el[0].href)
		const page = new URL(location.href);
		return page.host == url.host && page.pathname == url.pathname
	}

	#stopScroll(){
		$('html,body').stop();
	}

	#scroll(){
		this.#stopScroll()
		$(window).one('wheel', (event) => {
			this.#stopScroll();
		});
		$('html,body').animate({
			scrollTop: this.#top,
		},CONFIG.scrollAnim.speed, CONFIG.scrollAnim.easing, ()=> {
			$(window).off('wheel');
		});
	}
}

/**
スムーススクロールさせるやつ<br/>importするだけで使える<br/>[data-no-scroll]が付いてるとスクロールしない
@name smoothScroll

@example <caption>HTML</caption>
<p><a href="#scrollToSomewhere">これはスクロールする</a></p>
<p><a href="#scrollToSomewhere" data-no-scroll>これはスクロールしない</a></p>

@example <caption>JS</caption>
import '/assets/js/modules/smoothScroll.js';
*/
$(document).on('click', '[href*="#"]', function(event) {
	if($(this).is('[data-no-scroll]')) return
	new SmoothScroll(this)
});
